<template>
    <div class="pagamento operacao row">
        <!-- <h4>
            {{operacao.Descricao}}
        </h4> -->
        <div class="col-12 col-md-7 sep">
            <div>
                    <strong>Informações</strong><br/>

                    <p>{{ nomeEmpresa }} - {{ formatDocument(documento) }}</p>
                    <p><strong>ID Oportunidade</strong> {{ idOportunidade }} </p>
                    <p><strong>Parcela</strong> {{ parcela + 1 }} / {{ prazo }}</p>
            </div>


            <table class="info">
                <thead>
                    <th colspan="2">
                        Detalhes de Recebimento
                    </th>
                </thead>
                <tbody>
                    <tr>
                        <td>Principal</td>
                        <td class="text-right">R$ {{ formatarDinheiro(valorPrincipal) }}</td>
                    </tr>
                    <tr>
                        <td>Juros</td>
                        <td class="text-right">R$ + {{ juros ? formatarDinheiro(juros) : formatarDinheiro(0) }}</td>
                    </tr>
                    <tr>
                        <td>Multa por Atraso</td>
                        <td class="text-right">R$ + {{ multa ? formatarDinheiro(multa) : formatarDinheiro(0) }}</td>
                    </tr>
                    <tr>
                        <td>Valor Bruto (Principal + Juros + Multa)</td>
                        <td class="text-right">R$ {{ formatarDinheiro(valorBruto) }}</td>
                    </tr>
                    <tr>
                        <td>IR ({{aliquota}}%)</td>
                        <td class="text-right">R$ - {{ ir ? formatarDinheiro(ir) : formatarDinheiro(0) }}</td>
                    </tr>
                    <tr class="tfooter">
                        <td><strong>Liquido (Valor Bruto - IR)</strong></td>
                        <td class="text-right"><strong>R$ {{ formatarDinheiro(valorLiquido) }}</strong></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="detalhes col-12 col-md-5">
            <div class="options">
                <p>
                    ID da Fatura: 
                    <strong>
                        {{ fatura }}
                    </strong>
                </p>
                <p>
                    ID da Transação:
                    <strong>
                        {{ transacao }}
                    </strong>
                </p>

                <router-link  :to="`/investimentos/carteira-investimento/comprovante/pagamento/${operacao.id}?type=CREDITO`" class="btn btn-link">
                <img src="/static/assets/images/ico-printer-2.svg" alt="Icone impressora"> Imprimir detalhes
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import Masker from '@/utils/masker'

    export default {
        props: {
            operacao: {type: Object}
        },

        computed: {
            valorPrincipal() {
                if(this.operacao.Detalhes.Pagamento.Ipmt && this.operacao.Detalhes.Pagamento.Multa)
                    return this.operacao.Detalhes.Pagamento.ValorBruto - this.operacao.Detalhes.Pagamento.Ipmt - this.operacao.Detalhes.Pagamento.Multa
                else if(this.operacao.Detalhes.Pagamento.Ipmt && !this.operacao.Detalhes.Pagamento.Multa)
                    return this.operacao.Detalhes.Pagamento.ValorBruto - this.operacao.Detalhes.Pagamento.Ipmt
                else if(this.operacao.Detalhes.Pagamento.Multa && !this.operacao.Detalhes.Pagamento.Ipmt)    
                    return this.operacao.Detalhes.Pagamento.ValorBruto - this.operacao.Detalhes.Pagamento.Multa
                else
                    return this.operacao.Detalhes.Pagamento.ValorBruto
            },
            juros() {
                return this.operacao.Detalhes.Pagamento.Ipmt
            },
            valorBruto() {
                return this.operacao.Detalhes.Pagamento.ValorBruto
            },
            ir() {
                return this.operacao.Detalhes.Pagamento.Ir
            },
            valorLiquido() {
                return this.operacao.Valor
            },
            multa() {
                return this.operacao.Detalhes.Pagamento.Multa
            },
            transacao() {
                return this.operacao.id
            },
            fatura() {
                return this.operacao.Detalhes.Pagamento.FaturaId
            },
            idOportunidade() {
                return this.operacao.Detalhes.Pagamento.IdOportunidade
            },
            aliquota() {
                let ir = parseFloat(this.operacao.Detalhes.Pagamento.Ir)
                let juros = parseFloat(this.operacao.Detalhes.Pagamento.Ipmt)
                let multa = parseFloat(this.operacao.Detalhes.Pagamento.Multa)
                //calculo para operações SEM pagamento de multa
                if (ir && juros && !multa) {
                    let aliquota = parseFloat(Math.round((ir / juros) * 1000) / 10).toFixed(1)

                    switch(true) {
                        case aliquota < 1:
                            return 0;
                        case aliquota > 14 && aliquota < 16:
                            return 15.0;
                        case aliquota > 17 && aliquota < 18:
                            return 17.5;
                        case aliquota > 19 && aliquota < 21:
                            return 20.0;
                        case aliquota > 21.5:
                            return 22.5;    
                    }
                //calculo para operações com pagamento de multa    
                } else if (multa) {
                    let aliquota = parseFloat(Math.round((ir / (juros+multa)) * 1000) / 10).toFixed(1)

                    switch(true) {
                        case aliquota < 1:
                            return 0;
                        case aliquota > 14 && aliquota < 16:
                            return 15.0;
                        case aliquota > 17 && aliquota < 18:
                            return 17.5;
                        case aliquota > 19 && aliquota < 21:
                            return 20.0;
                        case aliquota > 21.5:
                            return 22.5;    
                    }
                } else if (!juros) {
                    return 0 
                } else {
                    return this.operacao.Detalhes.Pagamento.AliqIr
                }
            },
            parcela() {
                return this.operacao.Detalhes.Pagamento.IndiceParcela
            },
            prazo() {
                return this.operacao.Detalhes.Pagamento.Prazo
            },
            nomeEmpresa() {
                const { NomeEmpresa } = this.operacao.Detalhes.Pagamento
                return NomeEmpresa
            },
            documento() {
                const { DocumentoEmpresa } = this.operacao.Detalhes.Pagamento
                return DocumentoEmpresa || ""
            }
        },

        methods: {
            formatDocument(doc) {

                if(doc.length > 11) {
                    return Masker.maskCnpj(doc);
                } else {
                    return Masker.maskCpf(doc);
                }
            },
            formatarDinheiro(value) {

                if(value != null){

                    if(typeof value  == "string") value = parseFloat(value)

                    let options = { 
                        minimumFractionDigits: 2, 
                        maximumFractionDigits: 2
                    }

                    return value.toLocaleString('pt-BR', options )
                }

                return 0
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../assets/styles/iouu/variables";
	@import "../../../assets/styles/iouu/mixins";

    .operacao {
        h4 {
            text-transform: uppercase;
            font-size: 20px;

            @include xs {
                font-size: 14px;
            }
        }

        .detalhes {
            &{
                padding: 0 2rem;

                @include xs {
                    padding: 0 1rem;
                }
            }

            .decription {
                p {
                    &{
                        padding: 0;
                        margin: 0;
                        text-transform: uppercase;
                        padding-top: 1rem;
                        font-size: 16px;

                        @include xs {
                            font-size: 12px;
                            padding-top: 1rem;
                        }
                    }
                }
            }

            .info {
                tr {
                    &{
                        border-color: #ddd;
                    }

                    td {
                        @include xs {
                            font-size: 10px;
                        }
                    }

                    &.tfooter {
                       border-bottom: 0;
                       font-weight: 700;
                    }
                }
            }

            .options {

                p {
                    color: #000;
                }

                .btn {
                    &{
                        display: inline-block;
                        font-weight: 400;
                        text-align: center;
                        white-space: nowrap;
                        vertical-align: middle;
                        user-select: none;
                        border: 1px solid transparent;
                        padding: .75rem .75rem;
                        font-size: 1rem;
                        line-height: 1.25;
                        border-radius: .25rem;
                        transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
                    }

                    img {
                        width: 18px;
                    }

                    &-link {
                        color: #000;
                        font-size: 12px;
                        font-weight: 700;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Wallet/Operacoes/Pagamento.vue